import { AbstractControl, ValidatorFn } from '@angular/forms';

export const maxTwoDecimalsValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    let value = String(control.value);
    const index = value.indexOf('.');
    return (index !== -1 && value.substr(index).length > 3)
      ? { tooManyDecimals: true }
      : null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/decimals.validator.ts